import { useCallback } from 'react';
import { useAnalyticsClient } from '../useAnalyticsClient';
import { useAnalyticsSession } from '../useAnalyticsSession';
import { useAnalyticsProperty } from '../useAnalyticsProperty';
import { UserActionLoad } from 'rwl-shared/dist/models/analytics';
import { useAnalyticsTargetLayer } from '../useAnalyticsTargetLayer';
import { useAnalyticsTargetLayerArea } from '../useAnalyticsTargetLayerArea';

type LoadEventProps = Omit<
    UserActionLoad['data'],
    'targetLayer' | 'targetLayerId' | 'targetLayerArea'
>;

/**
 * Returns a function that, when called, sends a load event to the BI service
 */
export const useAnalyticsLoadEvent = () => {
    const { client } = useAnalyticsClient();
    const { session } = useAnalyticsSession();
    const { property } = useAnalyticsProperty();
    const { targetLayer, targetLayerId } = useAnalyticsTargetLayer();
    const { targetLayerArea } = useAnalyticsTargetLayerArea();

    return useCallback(
        (data: LoadEventProps) => {
            if (!client || !session) {
                console.warn(
                    '[RWL] BI client or session is not available, event will be lost'
                );
                return;
            }

            client.createLoadAction(session, property, {
                targetLayer,
                targetLayerId,
                targetLayerArea,
                ...data,
            });
        },
        [client, session, property, targetLayer, targetLayerId, targetLayerArea]
    );
};
